<script setup>
import { ref, computed, onMounted, onUnmounted, defineComponent } from 'vue'
import { useInfoStore } from '@/stores/counter.js'
import { showToast } from 'vant'
import encipher from '@/util/mySEC'
import { getReqData, LoginAPI, GetBindEmailAPI, GetUserInfoAPI, GetServerListAPI, GetGameRoleAPI, BindUserRoleAPI, GetEmailCodeAPI, GetBindEmailCodeAPI } from '@/util/api'
import { ElSelect, ElOption } from 'element-plus'

const ElementSelect = defineComponent(ElSelect)
const ElementOption = defineComponent(ElOption)

const userStore = useInfoStore()
const userInfo = computed(() => userStore.userInfo)

const emit = defineEmits(['close'])

const getUserInfo = (data) => {
  let reqData = {
    uname: data.uname,
    uid: data.uid,
    token: data.token
  }
  reqData = Object.assign({ pgid: '' }, reqData, JSON.parse(localStorage.getItem('href-url')))
  GetUserInfoAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        userStore.setUserInfo(Object.assign(data, res.data.data))
        localStorage.setItem('nsjkdjc==', encipher.des_encrypt(Object.assign(data, res.data.data)))
        if (res.data.data.is_bind_role == 0) {
          showDesktopLogin.value = false
          showDesktopBindCharacter.value = true
          getRegion()
        } else {
          closeModals()
          showToast({ type: 'success', message: 'Login successful!', className: 'toast-success' })
          window.dispatchEvent(
            new CustomEvent('user-session-ready', {
              detail: { userInfo: userStore.userInfo }
            })
          )
        }
      } else {
        showToast({ type: 'fail', message: res.data.msg, className: 'toast-fail' })
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}

// Desktop Login Modal State
let showDesktopLogin = ref(false)
let showDesktopResetPw = ref(false)
let showDesktopForgotAccount = ref(false)
let showDesktopEmailVerify = ref(false)
let showDesktopEmailResult = ref(false)
let desktopEmailResultType = ref('success') // 'success' or 'fail' or 'no_email' or 'login_fail'
let desktopEmailResultMsg = ref('')
let showDesktopBindCharacter = ref(false)
let resetUname = ref('')
let emailVerifyParams = ref({
  email: '',
  code: ''
})
const emailCodeCountdown = ref(0)
const emailCodeSending = ref(false)
let emailCodeTimer = null
let dLoginParams = ref({
  uname: '',
  upwd: '',
  remember: true
})

let regSection = ref([])
let regionalArr = ref([])
let regGroup = ref('')
let regDsname = ref('')
let role = ref('')
let roleData = ref({})
let dsData = ref({})

const getRegion = () => {
  GetServerListAPI(getReqData(JSON.parse(localStorage.getItem('href-url'))))
    .then((res) => {
      if (res.data.state == 1) {
        regSection.value = []
        let num = Math.ceil(res.data.data.length / 50)
        for (let i = 0; i < num; i++) {
          if (i * 50 + 50 > res.data.data.length) {
            let nameValue =
              '[S' +
              res.data.data[i * 50].dsid +
              ']' +
              '~' +
              '[S' +
              res.data.data[res.data.data.length - 1].dsid +
              ']'
            let reqArr = res.data.data.slice(i * 50)
            regSection.value.push({ id: i, name: nameValue, reqArr: reqArr })
          } else {
            let nameValue =
              '[S' +
              res.data.data[i * 50].dsid +
              ']' +
              '~' +
              '[S' +
              res.data.data[i * 50 + 49].dsid +
              ']'
            let reqArr = res.data.data.slice(i * 50, i * 50 + 50)
            regSection.value.push({ id: i, name: nameValue, reqArr: reqArr })
          }
        }
        regionalArr.value = regSection.value[0].reqArr
        regGroup.value = regSection.value[0].id
      } else {
        showToast({ type: 'fail', message: res.data.msg, className: 'toast-fail' })
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}

const checkGroup = (g) => {
  regionalArr.value = g.reqArr
  regDsname.value = ''
  role.value = ''
  roleData.value = {}
  dsData.value = {}
}

const checkDS = (d) => {
  dsData.value = d
  GetGameRole(d)
}

const GetGameRole = (r) => {
  let reqData = {
    uname: userInfo.value.uname,
    uid: userInfo.value.uid,
    token: userInfo.value.token
  }
  reqData = Object.assign(JSON.parse(localStorage.getItem('href-url')), reqData)
  reqData.dsid = r.dsid
  GetGameRoleAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        if (res.data.data && res.data.data.length > 0) {
          roleData.value = res.data.data[0]
          role.value = roleData.value.drname
        } else {
          roleData.value = {}
          role.value = ''
          showToast({
            type: 'fail',
            message: 'No character found on this server',
            className: 'toast-fail'
          })
        }
      } else {
        roleData.value = {}
        role.value = ''
        showToast({ type: 'fail', message: res.data.msg, className: 'toast-fail' })
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}

const bindUserRole = () => {
  if (!dsData.value.dsid) {
    showToast({ type: 'fail', message: 'Please select a server!', className: 'toast-fail' })
    return
  }
  if (!roleData.value.drid) {
    showToast({ type: 'fail', message: 'Please select your character!', className: 'toast-fail' })
    return
  }
  let reqData = {
    uname: userInfo.value.uname,
    uid: userInfo.value.uid,
    token: userInfo.value.token,
    dsid: dsData.value.dsid,
    dsname: dsData.value.dsname,
    accountid: roleData.value.accountid,
    drid: roleData.value.drid,
    drname: roleData.value.drname
  }
  reqData = Object.assign(Object.assign(JSON.parse(localStorage.getItem('href-url'))), reqData)
  BindUserRoleAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        showToast({
          type: 'success',
          message: 'Bind in-game character successfully!',
          className: 'toast-success'
        })
        showDesktopBindCharacter.value = false
        // Update user info
        let newReqData = {
          uname: userInfo.value.uname,
          uid: userInfo.value.uid,
          token: userInfo.value.token
        }
        newReqData = Object.assign(JSON.parse(localStorage.getItem('href-url')), newReqData)
        GetUserInfoAPI(getReqData(newReqData)).then((res2) => {
          if (res2.data.state == 1) {
            userStore.setUserInfo(Object.assign(userInfo.value, res2.data.data))
            localStorage.setItem(
              'nsjkdjc==',
              encipher.des_encrypt(Object.assign(userInfo.value, res2.data.data))
            )
            closeModals()
            window.dispatchEvent(
              new CustomEvent('user-session-ready', {
                detail: { userInfo: userStore.userInfo }
              })
            )
          }
        })
      } else {
        showToast({ type: 'fail', message: res.data.msg, className: 'toast-fail' })
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}

const handleDesktopLoginSubmit = () => {
  let uname = dLoginParams.value.uname.replace(/\s/g, '')
  let upwd = dLoginParams.value.upwd.replace(/\s/g, '')
  if (!uname) {
    showToast({ type: 'fail', message: 'Account cannot be empty', className: 'toast-fail' })
    return
  }
  if (!upwd) {
    showToast({ type: 'fail', message: 'Password cannot be empty', className: 'toast-fail' })
    return
  }
  let reqData = JSON.parse(localStorage.getItem('href-url')) || {}
  reqData.uname = uname
  reqData.upwd = upwd
  LoginAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        if (dLoginParams.value.remember) {
          let udata = {
            uname: uname,
            upwd: upwd,
            isSaveUi: true
          }
          localStorage.setItem('sdkfm=45653asd=55', encipher.des_encrypt(udata))
        } else {
          localStorage.removeItem('sdkfm=45653asd=55')
        }
        userStore.setUserInfo(res.data.data)
        localStorage.setItem('nsjkdjc==', encipher.des_encrypt(res.data.data))
        getUserInfo(res.data.data)
      } else {
        desktopEmailResultMsg.value = res.data.msg
        showDesktopLogin.value = false
        desktopEmailResultType.value = 'login_fail'
        showDesktopEmailResult.value = true
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}

const handleDesktopResetPwTrigger = () => {
  showDesktopLogin.value = false
  showDesktopResetPw.value = true
}

const handleDesktopResetPwSubmit = () => {
  let uname = resetUname.value.replace(/\s/g, '')
  if (!uname) {
    showToast({
      type: 'fail',
      message: 'Please enter your account number!',
      className: 'toast-fail'
    })
    return
  }
  // Need API call to verify account and go to next step
  // Using existing logic from LoginView.vue's findWay
  let reqData = {
    uname: uname
  }
  reqData = Object.assign(reqData, JSON.parse(localStorage.getItem('href-url')))
  GetBindEmailAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        if (res.data.data && res.data.data.isBindEmail == 0) {
          showDesktopResetPw.value = false
          desktopEmailResultType.value = 'no_email'
          showDesktopEmailResult.value = true
          setTimeout(() => {
            if (showDesktopEmailResult.value && desktopEmailResultType.value === 'no_email') {
              window.open('https://discord.gg/rise-of-elf-official', '_blank')
            }
          }, 4000)
        } else {
          emailVerifyParams.value.email = res.data.data.email
          showDesktopResetPw.value = false
          showDesktopForgotAccount.value = true
        }
      } else {
        showDesktopResetPw.value = false
        desktopEmailResultType.value = 'fail'
        showDesktopEmailResult.value = true
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}

const handleDesktopForgotAccountTrigger = () => {
  window.open('https://discord.gg/rise-of-elf-official', '_blank')
}

const handleDesktopResetPwByEmail = () => {
  showDesktopForgotAccount.value = false
  showDesktopEmailVerify.value = true
}

const handleDesktopEmailVerifyBack = () => {
  stopEmailCodeCountdown()
  showDesktopEmailVerify.value = false
  showDesktopForgotAccount.value = true
}

const stopEmailCodeCountdown = () => {
  if (emailCodeTimer) {
    clearInterval(emailCodeTimer)
    emailCodeTimer = null
  }
  emailCodeCountdown.value = 0
  emailCodeSending.value = false
}

const startEmailCodeCountdown = () => {
  if (emailCodeTimer) clearInterval(emailCodeTimer)
  emailCodeCountdown.value = 60
  emailCodeTimer = setInterval(() => {
    emailCodeCountdown.value -= 1
    if (emailCodeCountdown.value <= 0) stopEmailCodeCountdown()
  }, 1000)
}

const showEmailCodeError = (message) => {
  showToast({
    message: message || 'Failed to send verification code.',
    position: 'middle',
    duration: 3000,
    className: 'email-code-error-toast'
  })
}

const handleDesktopSendEmailCode = () => {
  if (emailCodeSending.value || emailCodeCountdown.value > 0) return
  if (!emailVerifyParams.value.email) {
    showToast({ type: 'fail', message: 'Please enter your E-mail!', className: 'toast-fail' })
    return
  }

  let reqData = {
    uname: resetUname.value,
    uid: userInfo.value?.uid || '0',
    token: userInfo.value?.token || '0',
    rid: 12,
    email: emailVerifyParams.value.email
  }
  reqData = Object.assign(reqData, JSON.parse(localStorage.getItem('href-url') || '{}'))

  emailCodeSending.value = true
  GetEmailCodeAPI(getReqData(reqData))
    .then((res) => {
      if (Number(res.data?.state) === 1) {
        emailCodeSending.value = false
        startEmailCodeCountdown()
        showToast({ type: 'success', message: 'Verification code sent.', className: 'toast-success' })
      } else {
        emailCodeSending.value = false
        showEmailCodeError(res.data?.msg)
      }
    })
    .catch((err) => {
      emailCodeSending.value = false
      showEmailCodeError(err?.response?.data?.msg || 'Network error, please try again.')
      console.log('[error]', err)
    })
}

const handleDesktopEmailVerifySubmit = () => {
  if (!emailVerifyParams.value.email) {
    showToast({ type: 'fail', message: 'Please enter your E-mail!', className: 'toast-fail' })
    return
  }
  if (!emailVerifyParams.value.code) {
    showToast({ type: 'fail', message: 'Please enter verification code!', className: 'toast-fail' })
    return
  }

  let reqData = {
    uname: resetUname.value,
    uid: userInfo.value?.uid || '0',
    token: userInfo.value?.token || '0',
    scode: emailVerifyParams.value.code,
    email: emailVerifyParams.value.email
  }
  reqData = Object.assign(reqData, JSON.parse(localStorage.getItem('href-url') || '{}'))

  GetBindEmailCodeAPI(getReqData(reqData))
    .then((res) => {
      stopEmailCodeCountdown()
      showDesktopEmailVerify.value = false
      if (res.data.state == 1) {
        desktopEmailResultType.value = 'success'
      } else {
        desktopEmailResultType.value = 'fail'
      }
      showDesktopEmailResult.value = true
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}

const handleDesktopContactCS = () => {
  // Navigate to or open the Customer Service view
  // For now we will just show a toast
  window.open('https://discord.gg/rise-of-elf-official', '_blank')
}

const handleDesktopForgotAccountBack = () => {
  showDesktopForgotAccount.value = false
  showDesktopResetPw.value = true
}

const closeModals = () => {
  stopEmailCodeCountdown()
  showDesktopLogin.value = false
  showDesktopResetPw.value = false
  showDesktopForgotAccount.value = false
  showDesktopEmailVerify.value = false
  showDesktopEmailResult.value = false
  showDesktopBindCharacter.value = false
  emit('close')
}

onUnmounted(() => {
  stopEmailCodeCountdown()
})

onMounted(() => {
  showDesktopLogin.value = true
  if (localStorage.getItem('sdkfm=45653asd=55')) {
    try {
      let cached = JSON.parse(encipher.des_decrypt(localStorage.getItem('sdkfm=45653asd=55')))
      if (cached && cached.uname && cached.upwd) {
        dLoginParams.value.uname = cached.uname
        dLoginParams.value.upwd = cached.upwd
        dLoginParams.value.remember = cached.isSaveUi !== false
      }
    } catch (e) {
      console.log(e)
    }
  }
})
</script>

<template>
  <div class="desktop-login-modal-wrapper">
    <!-- Desktop Login Modal -->
    <div v-if="showDesktopLogin" class="d-login-modal">
      <div class="d-login-mask" @click="closeModals()"></div>
      <div class="d-login-content">
        <img src="@/assets/img/web_home/弹窗切图/-h-登录框.png" class="d-login-bg" />
        <img
          src="@/assets/img/web_home/弹窗切图/关闭 拷贝 6.png"
          class="d-login-close"
          @click="closeModals()"
        />

        <div class="d-login-inner">
          <div class="d-login-row">
            <span class="d-login-label">Account</span>
          </div>
          <div class="d-login-input-wrapper">
            <img src="@/assets/img/web_home/弹窗切图/用户图标@2x.png" class="d-input-icon" />
            <input type="text" class="d-login-input" v-model="dLoginParams.uname" />
          </div>

          <div class="d-login-row">
            <span class="d-login-label">Password</span>
          </div>
          <div class="d-login-input-wrapper">
            <img src="@/assets/img/web_home/弹窗切图/密码@2x.png" class="d-input-icon" />
            <input type="password" class="d-login-input" v-model="dLoginParams.upwd" />
          </div>

          <img
            src="@/assets/img/web_home/弹窗切图/-h-Login.png"
            class="d-login-submit"
            @click="handleDesktopLoginSubmit"
          />

          <div class="d-login-options">
            <div class="d-remember-pw" @click="dLoginParams.remember = !dLoginParams.remember">
              <img
                v-if="dLoginParams.remember"
                src="@/assets/img/web_home/弹窗切图/打钩@2x.png"
                class="d-checkbox"
              />
              <img v-else src="@/assets/img/web_home/弹窗切图/未打钩@2x.png" class="d-checkbox" />
              <span>Remember Password</span>
            </div>
          </div>
          <div class="d-forgot-pw" @click="handleDesktopResetPwTrigger">Forgot your Password?</div>
        </div>
      </div>
    </div>

    <!-- Desktop Reset Password Modal -->
    <div v-if="showDesktopResetPw" class="d-login-modal">
      <div class="d-login-mask" @click="closeModals()"></div>
      <div class="d-login-content d-reset-content">
        <img src="@/assets/img/web_home/弹窗切图/-h-重置密码界面框.png" class="d-login-bg" />
        <img
          src="@/assets/img/web_home/弹窗切图/关闭 拷贝 6.png"
          class="d-login-close"
          @click="closeModals()"
        />

        <div class="d-reset-heading">
          <strong>Reset Password</strong>
          <span>Enter the Accountfor Password reset</span>
        </div>

        <div class="d-reset-inner">
          <div class="d-login-input-wrapper d-reset-input-wrapper">
            <input
              type="text"
              class="d-login-input d-reset-input"
              placeholder="Pls Enter ur Account"
              v-model="resetUname"
            />
          </div>

          <img
            src="@/assets/img/web_home/弹窗切图/Confirm.png"
            class="d-reset-submit"
            @click="handleDesktopResetPwSubmit"
          />

          <div class="d-forgot-account" @click="handleDesktopForgotAccountTrigger">
            Forgot Account
          </div>
        </div>
      </div>
    </div>

    <!-- Desktop Forgot Account Modal -->
    <div v-if="showDesktopForgotAccount" class="d-login-modal">
      <div class="d-login-mask" @click="closeModals()"></div>
      <div class="d-login-content d-forgot-content">
        <img src="@/assets/img/web_home/弹窗切图/-h-重置密码选择界面框.png" class="d-login-bg" />
        <img
          src="@/assets/img/web_user/05用户中心/01个人信息/返回.png"
          class="d-modal-back"
          @click="handleDesktopForgotAccountBack"
        />
        <img
          src="@/assets/img/web_home/弹窗切图/关闭 拷贝 6.png"
          class="d-login-close"
          @click="closeModals()"
        />

        <div class="d-forgot-heading">Reset Password</div>

        <div class="d-forgot-inner">
          <img
            src="@/assets/img/web_home/弹窗切图/-h-Reset Password By E-mail.png"
            class="d-forgot-btn"
            @click="handleDesktopResetPwByEmail"
          />
          <img
            src="@/assets/img/web_home/弹窗切图/-h-Contact Customer Service.png"
            class="d-forgot-btn"
            @click="handleDesktopContactCS"
          />
          <img
            src="@/assets/img/web_home/弹窗切图/-h-Back.png"
            class="d-forgot-btn-back"
            @click="handleDesktopForgotAccountBack"
          />
        </div>
      </div>
    </div>

    <!-- Desktop Email Verification Modal -->
    <div v-if="showDesktopEmailVerify" class="d-login-modal">
      <div class="d-login-mask" @click="closeModals()"></div>
      <div class="d-login-content d-email-content">
        <img src="@/assets/img/web_home/弹窗切图/-h-邮件重置界面框.png" class="d-login-bg" />
        <img
          src="@/assets/img/web_user/05用户中心/01个人信息/返回.png"
          class="d-modal-back"
          @click="handleDesktopEmailVerifyBack"
        />
        <img
          src="@/assets/img/web_home/弹窗切图/关闭 拷贝 6.png"
          class="d-login-close"
          @click="closeModals()"
        />

        <div class="d-email-heading">E-mail verification</div>

        <div class="d-email-verify-inner">
          <div class="d-email-form-group">
            <div class="d-email-label">E-mail:</div>
            <div class="d-email-input-row">
              <input type="text" class="d-email-input" v-model="emailVerifyParams.email" readonly />
              <button
                type="button"
                class="d-email-send-btn"
                :class="{ disabled: emailCodeSending || emailCodeCountdown > 0 }"
                :disabled="emailCodeSending || emailCodeCountdown > 0"
                @click="handleDesktopSendEmailCode"
              >
                {{ emailCodeCountdown > 0 ? `${emailCodeCountdown}s` : (emailCodeSending ? 'Sending...' : 'Send') }}
              </button>
            </div>
          </div>

          <div class="d-email-form-group">
            <div class="d-email-label">Verification code:</div>
            <input
              type="text"
              class="d-email-input d-email-input-full"
              v-model="emailVerifyParams.code"
            />
          </div>

          <img
            src="@/assets/img/web_home/弹窗切图/Confirm.png"
            class="d-email-submit"
            @click="handleDesktopEmailVerifySubmit"
          />
        </div>
      </div>
    </div>

    <!-- Desktop Email Verification Result Modal -->
    <div v-if="showDesktopEmailResult" class="d-login-modal">
      <div class="d-login-mask" @click="closeModals()"></div>
      <div class="d-login-content">
        <img
          v-if="desktopEmailResultType === 'success'"
          src="@/assets/img/web_home/弹窗切图/-h-成功重置密码弹窗框.png"
          class="d-login-bg"
        />
        <img v-else src="@/assets/img/web_home/弹窗切图/-h-无效账号弹窗框.png" class="d-login-bg" />
        <img
          src="@/assets/img/web_home/弹窗切图/关闭 拷贝 6.png"
          class="d-login-close"
          @click="closeModals()"
        />

        <div class="d-email-result-inner">
          <img
            v-if="desktopEmailResultType === 'success'"
            src="@/assets/img/web_home/弹窗切图/Your password has been reset and sent to your email. Pleasechec.png"
            class="d-result-text-img"
          />
          <img
            v-else-if="desktopEmailResultType === 'fail'"
            src="@/assets/img/web_home/弹窗切图/Sorry,the account you entered does not exist. Please check and_.png"
            class="d-result-text-img-fail"
          />
          <div v-else-if="desktopEmailResultType === 'no_email'" class="d-no-email-text">
            No email linked to this account. Please contact CS support.<br/>
            Official Community link: <br/><a href="https://discord.gg/rise-of-elf-official" target="_blank">https://discord.gg/rise-of-elf-official</a>
          </div>
          <div v-else-if="desktopEmailResultType === 'login_fail'" class="d-login-fail-text">
            {{ desktopEmailResultMsg }}
          </div>
        </div>
      </div>
    </div>

    <!-- Desktop Bind Character Modal -->
    <div v-if="showDesktopBindCharacter" class="d-login-modal">
      <div class="d-login-mask" @click="closeModals()"></div>
      <div class="d-login-content">
        <img src="@/assets/img/web_user/switch_character/bg.png" class="d-login-bg" />
        <img
          src="@/assets/img/web_home/弹窗切图/关闭 拷贝 6.png"
          class="d-login-close"
          @click="closeModals()"
        />

        <div class="d-bind-character-inner">
          <div class="select-container">
            <ElementSelect
              v-model="regGroup"
              placeholder="Pls Select your server range"
              size="large"
              class="custom-blue-select"
            >
              <ElementOption
                v-for="item in regSection"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                @click="checkGroup(item)"
              />
            </ElementSelect>
          </div>
          <div class="select-container">
            <ElementSelect
              v-model="regDsname"
              placeholder="Pls Select your server"
              size="large"
              class="custom-blue-select"
            >
              <ElementOption
                v-for="d in regionalArr"
                :key="d.id"
                :label="'[' + d.dsid + '] ' + d.dsname"
                :value="d.id"
                @click="checkDS(d)"
              />
            </ElementSelect>
          </div>
          <div class="select-container">
            <ElementSelect
              v-model="role"
              placeholder="Pls Select your Character"
              size="large"
              class="custom-blue-select"
              disabled
            >
              <ElementOption
                v-if="roleData.drname"
                :label="roleData.drname"
                :value="roleData.drname"
              />
            </ElementSelect>
          </div>
          <img
            src="@/assets/img/web_user/switch_character/confirm.png"
            class="d-bind-submit"
            @click="bindUserRole"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Desktop Login Modal CSS */
.d-login-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.d-login-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
}
.d-login-content {
  position: relative;
  z-index: 2;
  width: 400px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.d-login-bg {
  width: 100%;
  height: auto;
}
.d-login-close {
  position: absolute;
  top: -15px;
  right: -15px;
  width: 35px;
  cursor: pointer;
  z-index: 3;
}
.d-login-inner {
  position: absolute;
  top: 80px; /* Adjust based on the background image header */
  left: 0;
  width: 100%;
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.d-login-row {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 5px;
}
.d-login-label {
  color: #1e5bb8;
  font-weight: bold;
  font-size: 14px;
  margin-left: 5px;
}
.d-login-input-wrapper {
  width: 100%;
  height: 40px;
  border: 2px solid #5ea0f8;
  border-radius: 20px;
  background: #e8f4ff;
  display: flex;
  align-items: center;
  padding: 0 15px;
  margin-bottom: 15px;
}
.d-input-icon {
  width: 24px;
  margin-right: 10px;
}
.d-login-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  font-size: 16px;
  color: #333;
}
.d-login-submit {
  width: 60%;
  margin-top: 10px;
  cursor: pointer;
}
.d-login-options {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.d-remember-pw {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #26a546;
  font-weight: bold;
  font-size: 13px;
}
.d-checkbox {
  width: 18px;
  margin-right: 5px;
}
.d-forgot-pw {
  color: #ff4d4f;
  font-size: 15px;
  margin-top: 5px;
  cursor: pointer;
  text-decoration: underline;
}
.d-reset-inner {
  position: absolute;
  top: 120px; /* Adjust based on the Reset Password background image header */
  left: 0;
  width: 100%;
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.d-reset-heading {
  display: none;
}
.d-forgot-heading,
.d-email-heading,
.d-modal-back {
  display: none;
}
.d-reset-input-wrapper {
  border-color: #1e5bb8;
  background: #e8f4ff;
  margin-bottom: 25px;
}
.d-reset-input {
  text-align: center;
  color: #1e5bb8;
  font-weight: bold;
}
.d-reset-input::placeholder {
  color: #1e5bb8;
  font-weight: bold;
  opacity: 0.8;
}
.d-reset-submit {
  width: 65%;
  margin-top: 10px;
  cursor: pointer;
}
.d-forgot-account {
  color: #ff8b7b;
  font-size: 14px;
  margin-top: 20px;
  cursor: pointer;
  text-decoration: underline;
}
.d-forgot-inner {
  position: absolute;
  top: 100px; /* Adjust based on the Forgot Account background image header */
  left: 0;
  width: 100%;
  padding: 0 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}
.d-forgot-btn {
  width: 100%;
  cursor: pointer;
  transition: transform 0.1s ease;
}
.d-forgot-btn:active {
  transform: scale(0.98);
}
.d-forgot-btn-back {
  width: 100%;
  cursor: pointer;
  transition: transform 0.1s ease;
  margin-top: 10px;
}
.d-forgot-btn-back:active {
  transform: scale(0.98);
}
.d-email-verify-inner {
  position: absolute;
  top: 90px; /* Adjust based on the E-mail verification background image header */
  left: 0;
  width: 100%;
  padding: 0 40px;
  display: flex;
  flex-direction: column;
}
.d-email-form-group {
  margin-bottom: 15px;
}
.d-email-label {
  color: #1e5bb8;
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 5px;
}
.d-email-input-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.d-email-input {
  flex: 1;
  height: 40px;
  border: 2px solid #1e5bb8;
  border-radius: 20px;
  background: #e8f4ff;
  padding: 0 15px;
  color: #1e5bb8;
  font-weight: bold;
  outline: none;
  min-width: 0;
}
.d-email-input-full {
  width: 100%;
}
.d-email-send-btn {
  height: 40px;
  padding: 0 8px;
  border: 2px solid #075197;
  border-radius: 15px;
  background: linear-gradient(180deg, #91f1e5 0%, #68a9ed 100%);
  box-shadow: 0 2px 0 #063c75;
  color: #073e73;
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: transform 0.1s ease;
}
.d-email-send-btn:active {
  transform: scale(0.98);
}
.d-email-send-btn.disabled {
  cursor: default;
  filter: saturate(.75);
}
.d-email-submit {
  width: 65%;
  margin: 20px auto 0;
  display: block;
  cursor: pointer;
  transition: transform 0.1s ease;
}
.d-email-submit:active {
  transform: scale(0.98);
}
.d-email-result-inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 40px;
}
.d-result-text-img {
  width: 90%;
  margin-top: 10px;
}
.d-result-text-img-fail {
  width: 90%;
  margin-top: -30px;
}
.d-no-email-text {
  width: 90%;
  margin-top: -20px;
  text-align: center;
  color: #1e5bb8;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.5;
}
.d-no-email-text a {
  color: #1e5bb8;
  text-decoration: underline;
}
.d-login-fail-text {
  width: 90%;
  text-align: center;
  color: #1e5bb8;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.5;
}

/* Bind Character CSS */
.d-bind-character-inner {
  position: absolute;
  top: 90px;
  left: 0;
  width: 100%;
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
}

.select-container {
  width: 100%;
}

.custom-blue-select {
  width: 100%;
}

:deep(.custom-blue-select .el-input__wrapper) {
  border: 2px solid #5ea0f8;
  border-radius: 20px;
  box-shadow: none !important;
  padding: 5px 15px;
  background-color: #e8f4ff;
}

:deep(.custom-blue-select .el-input__inner) {
  color: #333;
  font-weight: normal;
  font-size: 14px;
}

:deep(.custom-blue-select .el-input__inner::placeholder) {
  color: #1e5bb8;
}

.d-bind-submit {
  width: 60%;
  margin-top: 15px;
  cursor: pointer;
}

@media screen and (max-width: 920px) {
  .d-login-content {
    width: min(84vw, 320px);
  }

  .d-login-close {
    top: -11px;
    right: -10px;
    width: 31px;
  }

  .d-login-inner {
    top: 62px;
    padding: 0 30px;
  }

  .d-login-row {
    margin-bottom: 3px;
  }

  .d-login-label {
    margin-left: 3px;
    font-size: 12px;
  }

  .d-login-input-wrapper {
    height: 37px;
    border-radius: 10px;
    padding: 0 10px;
  }

  .d-input-icon {
    width: 21px;
    margin-right: 7px;
  }

  .d-login-input {
    min-width: 0;
    font-size: 13px;
  }

  .d-login-submit {
    width: 56%;
    margin-top: 12px;
  }

  .d-login-options {
    margin-top: 8px;
    font-size: 11px;
  }

  .d-remember-pw img {
    width: 15px;
  }

  .d-forgot-pw {
    font-size: 10px;
  }

  .d-reset-content {
    width: min(calc(100vw - 10px), 390px);
  }

  .d-reset-heading {
    position: absolute;
    top: 15px;
    left: 40px;
    right: 40px;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #fff;
    text-align: center;
    text-shadow:
      -2px -2px 0 #14569a,
      2px -2px 0 #14569a,
      -2px 2px 0 #14569a,
      2px 2px 0 #14569a;
  }

  .d-reset-heading strong {
    font-size: clamp(22px, 6vw, 27px);
    line-height: 1.05;
  }

  .d-reset-heading span {
    margin-top: 5px;
    font-size: clamp(10px, 3vw, 13px);
    font-weight: 800;
    line-height: 1;
    text-shadow: none;
  }

  .d-reset-content .d-login-close {
    top: -13px;
    right: -7px;
    width: 38px;
  }

  .d-reset-inner {
    top: 120px;
    padding: 0 42px;
  }

  .d-reset-content .d-reset-input-wrapper {
    height: 47px;
    margin-bottom: 22px;
    border-width: 2px;
    border-radius: 12px;
  }

  .d-reset-content .d-reset-input {
    font-size: clamp(14px, 4vw, 17px);
  }

  .d-reset-content .d-reset-submit {
    width: 62%;
    margin-top: 8px;
  }

  .d-reset-content .d-forgot-account {
    margin-top: 22px;
    color: #ff5b38;
    font-size: clamp(13px, 3.7vw, 16px);
  }

  .d-forgot-content,
  .d-email-content {
    width: min(calc(100vw - 10px), 390px);
  }

  .d-forgot-heading,
  .d-email-heading {
    position: absolute;
    top: 14px;
    left: 48px;
    right: 48px;
    z-index: 3;
    display: block;
    color: #fff;
    font-size: clamp(21px, 5.8vw, 27px);
    font-weight: 900;
    line-height: 1.1;
    text-align: center;
    text-shadow:
      -2px -2px 0 #14569a,
      2px -2px 0 #14569a,
      -2px 2px 0 #14569a,
      2px 2px 0 #14569a;
  }

  .d-modal-back {
    position: absolute;
    top: 9px;
    left: 9px;
    z-index: 5;
    display: block;
    width: 34px;
    height: 34px;
    object-fit: contain;
    cursor: pointer;
  }

  .d-forgot-content .d-forgot-heading {
    top: 25px;
  }

  .d-forgot-content .d-modal-back {
    top: 20px;
  }

  .d-forgot-content .d-forgot-btn,
  .d-forgot-content .d-forgot-btn-back {
    width: 90%;
  }

  .d-forgot-content .d-login-close,
  .d-email-content .d-login-close {
    top: -12px;
    right: -7px;
    width: 37px;
  }

  .d-email-content .d-email-verify-inner {
    top: 27%;
    padding: 0 31px;
  }

  .d-email-content .d-email-form-group {
    margin-bottom: 10px;
  }

  .d-email-content .d-email-label {
    margin-bottom: 4px;
    font-size: clamp(11px, 3vw, 13px);
  }

  .d-email-content .d-email-input-row {
    gap: 2px;
  }

  .d-email-content .d-email-input {
    height: 43px;
    padding: 0 10px;
    border-radius: 10px;
    font-size: clamp(12px, 3.4vw, 15px);
  }

  .d-email-content .d-email-send-btn {
    width: 36%;
    height: 35px;
    flex: 0 0 36%;
    padding: 0 4px;
    font-size: clamp(13px, 3.8vw, 16px);
  }

  .d-email-content .d-email-submit {
    width: 61%;
    margin-top: 10px;
  }
}
</style>
